import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Placeholder } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import useMountEffect from '../../../hooks/useMountEffect';
import styles from './styles.scss';
import { getListingImageUrl } from '../../../utils/listing';
const cx = classnames.bind(styles);
const ListingImage = ({ listing = {}, url = '', encode = true, alt = 'Listing Image', rounded = true, className = '', elmId, loading = false, featureFlags, }) => {
    const getValidImageUrl = url => {
        if (loading)
            return '';
        const encodedUrl = encode ? encodeURI(url) : url;
        return getListingImageUrl(encodedUrl, featureFlags);
    };
    const [imgUrl, setImgUrl] = useState(listing.primary_photo || url);
    useMountEffect(() => setImgUrl(getValidImageUrl(listing.primary_photo || url)));
    useEffect(() => setImgUrl(getValidImageUrl(listing.primary_photo || url)), [listing.primary_photo || url, loading]);
    const onError = () => {
        setImgUrl(getListingImageUrl());
    };
    return !imgUrl ? (_jsx("div", { className: cx('placeholder-container'), children: _jsx(Placeholder, { className: cx('placeholder', className, rounded && 'border-radius') }) })) : (_jsx("img", { className: cx('image', className, rounded && 'border-radius'), src: imgUrl, alt: alt, onError: onError, "data-elm-id": elmId }));
};
ListingImage.propTypes = {
    listing: PropTypes.object,
    featureFlags: PropTypes.object,
    url: PropTypes.string,
    encode: PropTypes.bool,
    alt: PropTypes.string,
    rounded: PropTypes.bool,
    className: PropTypes.string,
    elmId: PropTypes.string,
    loading: PropTypes.bool,
};
export default ListingImage;
//# sourceMappingURL=index.js.map